import _ from 'lodash'
import Mustache from 'mustache'
import MESSAGES from 'core/data-model/constants/bi-messages'

const _getRiderFH = (riders) => _.find(riders, (rider) => rider.code === 'FH')

const _isPackageInstance = (plan) => _.includes(['PLATINUM', 'DIAMOND'], plan.toUpperCase())

const _isPlatinum = (plan) => _.includes(['PLATINUM'], plan.toUpperCase())
export const getFlexiHealthTitlePolicyValueTable = ({ riders }) => {
  const riderFH = _getRiderFH(riders)
  const plan = _.get(riderFH, 'selectedPlan.plan', '')
  const title = _isPackageInstance(plan) ? MESSAGES.POLICY_VALUE_TABLE_ONE : MESSAGES.POLICY_VALUE_TABLE_TWO
  return Mustache.render(title, { productName: _.get(riderFH, 'description') })
}

export const isPlatinum = ({ riders }) => {
  const riderFH = _getRiderFH(riders)
  const plan = _.get(riderFH, 'selectedPlan.plan', '')
  return _isPlatinum(plan)
}
